import { render, staticRenderFns } from "./HeaderDeRecebimentos.vue?vue&type=template&id=f2f9c0fe&scoped=true"
import script from "./HeaderDeRecebimentos.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderDeRecebimentos.vue?vue&type=script&setup=true&lang=js"
import style0 from "./HeaderDeRecebimentos.vue?vue&type=style&index=0&id=f2f9c0fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f9c0fe",
  null
  
)

export default component.exports